import React from 'react';
import './Header.css';
import ProfileDropdown from './ProfileDropdown';
import SettingsDialog from '../SettingsDialog';
import { AppBar, Toolbar, Button, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import LoginPopup from '../LoginPopup';
import RegistrationDialog from '../RegistrationDialog';
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    header: {
        backgroundColor: '#000'
    },
    headerTypometryLogo: {
        color: '#fff',
        fontFamily: 'garamond-premier-pro, serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontKerning: 'normal',
        fontSize: '2em',
        '&:hover': {
            color: '#bbb',
            textDecoration: 'none'
        }
    },
    whiteText: {
        color: '#fff',
        '&:hover': {
            color: '#bbb'
        }
    },
    toolbarButtons: {
        marginLeft: 'auto'
    },
    or: {
        color: '#fff',
        padding: theme.spacing(1)
    }
}));
function Header(props) {
    const classes = useStyles();
    const [showSettings, setShowSettings] = React.useState(false);
    const [showRegistration, setShowRegistration] = React.useState(false);
    function handleOpenSettings() {
        setShowSettings(true);
    }
    function handleCloseSettings() {
        setShowSettings(false);
    }
    function handleOpenRegistration() {
        setShowRegistration(true);
    }
    function handleCloseRegistration() {
        setShowRegistration(false);
    }
    const { setDarkTheme } = props;
    return (React.createElement("div", { className: classes.root },
        React.createElement(SettingsDialog, { open: showSettings, handleClose: handleCloseSettings, setDarkTheme: setDarkTheme }),
        React.createElement(RegistrationDialog, { open: showRegistration, handleClose: handleCloseRegistration }),
        React.createElement(AppBar, { position: 'static', className: classes.header },
            React.createElement(Toolbar, null,
                React.createElement(Link, { variant: 'h3', href: '/', className: classes.headerTypometryLogo }, "Typometry"),
                React.createElement("div", { className: classes.toolbarButtons }, window.is_logged_in ?
                    React.createElement(ProfileDropdown, { avatar: window.avatar_url, name: window.name, openSettings: handleOpenSettings })
                    :
                        React.createElement("span", null,
                            React.createElement(LoginPopup, { openRegistration: handleOpenRegistration }),
                            React.createElement("span", { className: classes.or }, "or"),
                            React.createElement(Button, { className: classes.whiteText, variant: 'text', onClick: handleOpenRegistration }, "Sign up")))))));
}
export default Header;
//# sourceMappingURL=Header.js.map